"use strict";

import NormalCardView from "/js/card-views/normal-card-view.js";
import CoverCardView from "/js/card-views/cover-card-view.js";
import SummaryCardView from "/js/card-views/summary-card-view.js";
import TipCardView from "/js/card-views/tip-card-view.js";
import InteractionCardView from "/js/card-views/interaction-card-view.js";
import GalleryCardView from "/js/card-views/gallery-card-view.js";
import TapRevealCardView from "/js/card-views/tap-reveal-card-view.js";
import UnsupportedCardView from "/js/card-views/unsupported-card-view.js";

export default class CardViewUtil {

  /**
   * Returns a Card subclass instance based on `layout` property.
   */
  static makeCardView(data, explicitSkillId=null) {
    let card;
    switch (data.layout) {
      case 'normal':
        card = new NormalCardView(data);
        break;
      case 'cover':
        card = new CoverCardView(data, explicitSkillId);
        break;
      case 'summary':
        card = new SummaryCardView(data);
        break;
      case 'tip':
        card = new TipCardView(data);
        break;
      case 'interaction':
        card = new InteractionCardView(data);
        break;
      case 'tap-to-reveal':
        card = new TapRevealCardView(data);
        break;
      case 'gallery':
        card = new GalleryCardView(data);
        break;
      default:
        card = new UnsupportedCardView(data);
        break;
    }
    return card;
  }
}
